import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Invoice } from '../../models/invoice';
import { InvoicesService } from '../services/invoices.service';
import { InvoiceFilter } from '../../models/invoice-filter';
import * as moment from 'moment';

@Component({
	selector: 'app-invoice-search',
	templateUrl: 'invoice-search.template.html'
})

/**
 * Component used for searching invoices
 */
export class InvoiceSearchComponent
{
    /**
	 * Event that fires when typing into the searchb bar.
	 *
	 * @type {EventEmitter<InvoiceFilter>}
	 */
	@Output() onSearchInput = new EventEmitter<InvoiceFilter>();

    /**
	 * Update the search word. Emits the onSearchInput event
	 *
	 * @param {KeyboardEvent} event
	 *
	 * @returns void
	 */
	updateSearchInput(event: KeyboardEvent): void
  {
    if(event.key == "Enter") {
      const filters: InvoiceFilter = {
      year: null,
      week: null,
      search: (<HTMLInputElement>event.target).value
    };

      (<HTMLInputElement>event.target).value = '';
      this.onSearchInput.emit(filters);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-search/invoice-search.component.ts